import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

import {
  collection,
  getDocs,
  db,
  query,
  startAfter,
  limit,
  orderBy,
} from '../../FirebaseInit';


const initialState = {
  movie: [],
  isEndReached:false,
  isLoading: false,
  isError: false,
  error: ''
};
var lastDoc = null;
export const loadMovie = createAsyncThunk('movie/loadMovie',
  () => {
    return new Promise(async (res, rej) => {
      try {
        const movieRef = query(collection(db, 'movie'),orderBy('createdAt','desc'), limit(12));

        const querySnapShot = await getDocs(movieRef);
        const list = [];
        querySnapShot.forEach(doc => {
          list.push({...doc.data()});
        });
        lastDoc = querySnapShot.docs.length > 0 ? querySnapShot.docs[querySnapShot.docs.length - 1] : null;
        res(list);
      } catch (e) {
        console.log(e.message);
        rej(e.message);
      }
    });
  });

export const loadMoreMovie = createAsyncThunk('movie/loadMoreMovie',
  () => {
    return new Promise(async (res, rej) => {
      try {
        const movieRef = query(collection(db, 'movie'), orderBy("createdAt", 'desc'), startAfter(lastDoc), limit(12));
        const querySnapShot = await getDocs(movieRef);

        const list = [];
        querySnapShot.forEach(doc => {
          list.push({...doc.data()});
        });
        lastDoc = querySnapShot.docs.length > 0 ? querySnapShot.docs[querySnapShot.docs.length - 1] : null;
        res(list);
      } catch (e) {
        console.log(e.message);
        rej(e.message);
      }
    });
  });



export const movieSlice = createSlice({
  name: "movie",
  initialState,
  extraReducers: (builder) => {
    //loadMovie
    builder.addCase(loadMovie.pending, (state, _) => {
      state.isLoading = true;
      state.isError = false;
      state.error = '';
    });
    builder.addCase(loadMovie.fulfilled, (state, {payload}) => {
      state.movie = payload;
      state.isEndReached = payload.length < 12
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    });
    builder.addCase(loadMovie.rejected, (state, {payload}) => {
      state.isLoading = false;
      state.isError = true;
      state.error = payload;
    });

    //loadMoreMovie
    builder.addCase(loadMoreMovie.pending, (state, _) => {
      state.isLoading = true;
      state.isError = false;
      state.error = '';
    });
    builder.addCase(loadMoreMovie.fulfilled, (state, {payload}) => {
      state.movie = [...state.movie, ...payload];
      state.isLoading = false;
      state.isEndReached = payload.length < 12
      state.isError = false;
      state.error = "";
    });
    builder.addCase(loadMoreMovie.rejected, (state, {payload}) => {
      state.isLoading = false;
      state.isError = true;
      state.error = payload;
    });
  }
});

export const movieReducer = movieSlice.reducer;